import React from 'react'
import {Icon} from '@chakra-ui/react'

const PlayIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <circle cx="12" cy="12" r="12" fill="background.neutral.default" />
            <path
                d="M15.9004 11.134C16.5671 11.5189 16.5671 12.4811 15.9004 12.866L10.8004 15.8105C10.1337 16.1954 9.30039 15.7143 9.30039 14.9445L9.30039 9.05552C9.30039 8.28572 10.1337 7.80459 10.8004 8.18949L15.9004 11.134Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default PlayIcon
